var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row",
    style: _vm.diffStyle
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.detail.material ? _vm.detail.material.model ? _vm.detail.material.model : _vm.detail.material.name : "错误") + " ")]), _c('div', [_vm._v(_vm._s((_vm.detail.ratio * 100).toFixed(3)) + "%")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }